import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { PushSettingsCard } from '@/components/PushSettingsCard';

/**
 * Account settings > « Notifications sur cet appareil ».
 * One place for every role (traveller, provider, administrator), reached from the account
 * menu of the header (desktop menu and phone menu). Private page: /account/notifications.
 */
export default function AccountNotificationsPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 pt-24 pb-14 sm:pt-28 sm:pb-20">
       <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="account-notifications-page">
        <Link to="/dashboard" className="inline-flex min-h-[44px] items-center text-sm font-medium text-primary underline underline-offset-4 hover:text-primary-light" data-testid="account-back-link">{t('accountSettings.back')}</Link>
        <h1 className="mt-3 mb-6 text-2xl font-bold text-primary">{t('accountSettings.title')}</h1>
        <PushSettingsCard />
       </div>
      </main>
      <Footer />
    </div>
  );
}
